import React from 'react';
import {
  StyledGender,
  StyledGenderPicker,
  StyledIconContainer,
  StyledTitle
} from './style';
import Icon from '../../Common/Icon';
import { useTranslation } from 'react-i18next';

type GenderPickerType = {
  status: string;
  onClick: (status: string) => void;
};
const GenderPicker: React.FC<GenderPickerType> = ({ status, onClick }) => {
  const { t } = useTranslation();
  return (
    <StyledGenderPicker>
      {['Female', 'Male'].map((item) => (
        <StyledGender
          isActive={status === item}
          key={item}
          onClick={() => onClick(item)}
          status={item}>
          <StyledTitle>{t(`global.${item.toLowerCase()}`)}</StyledTitle>
          <StyledIconContainer status={item} isActive={status === item}>
            <Icon
              name={`${item.toLowerCase()}-user`}
              color="secondaryButtonText"
              fontSize={6}
            />
          </StyledIconContainer>
        </StyledGender>
      ))}
    </StyledGenderPicker>
  );
};

export default GenderPicker;
